import { toast } from "react-toastify"
import { api } from "../../Lib/constants"
import { ADD_ATTENDANCE, ADD_ATTENDANCE_FAILED, ADD_ATTENDANCE_SUCCESS, ATTENDANCE, ATTENDANCE_FAILED, ATTENDANCE_SUCCESS, UPDATE_ATTENDANCE, UPDATE_ATTENDANCE_FAILED, UPDATE_ATTENDANCE_SUCCESS } from "./actionTypes"
import { getAuthHeader } from "../../Lib/utils"


export const getAttendance = (id) => async (dispatch) => {
  dispatch({
    type: ATTENDANCE,
  });
  try {
    let response = await api(`attendance/attendanceList/${id}`, "get", {}, getAuthHeader());
    dispatch({
      type: ATTENDANCE_SUCCESS,
      payload: response?.data,
    });
    return response;
  } catch (error) {
    console.log("while fetching Attendance list error ====>", error);
    return dispatch({
      type: ATTENDANCE_FAILED,
      payload: error?.message,
    });
  }
};

export const getAllAttendance = () => async (dispatch) => {
  dispatch({
    type: ATTENDANCE,
  });
  try {
    let response = await api(`attendance/all`, "get", {}, getAuthHeader());
    dispatch({
      type: ATTENDANCE_SUCCESS,
      payload: response?.data,
    });
    return response;
  } catch (error) {
    console.log("while fetching all Attendances list error ====>", error);
    return dispatch({
      type: ATTENDANCE_FAILED,
      payload: error?.message,
    });
  }
};

export const addAttendance = (data) => async dispatch => {
  dispatch({
    type: ADD_ATTENDANCE
  })
  try {
    let response = await api(`attendance/add`, 'post', data, getAuthHeader())
    console.log('add attendance data', response);
    toast.success("Attendance Saved Successfully");
    dispatch({
      type: ADD_ATTENDANCE_SUCCESS,
      payload: response?.data
    })
    return response
  } catch (error) {
    console.log("while Adding attendance error ====>>>", error);
    toast.error(error?.message);
    return dispatch({
      type: ADD_ATTENDANCE_FAILED,
      payload: error?.message
    })
  }
}

export const updateAttendance = (id, data) => async dispatch => {
  dispatch({
    type: UPDATE_ATTENDANCE
  })
  try {
    let response = await api(`attendance/update/${id}`, 'put', data, getAuthHeader())
    console.log('update attendance data', response);
    toast.success("Attendance Updated Successfully");
    dispatch({
      type: UPDATE_ATTENDANCE_SUCCESS,
      payload: response?.data
    })
    return response
  } catch (error) {
    console.log("while updating attendance error ====>>>", error);
    toast.error(error?.message);
    return dispatch({
      type: UPDATE_ATTENDANCE_FAILED,
      payload: error?.message
    })
  }
}